import React, { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Divider, message, Modal, Row } from "antd";
import { Button } from "@mui/material";

interface IDeleteConfirmationModalProps {
  title: string;
  visibility: boolean;
  body: React.ReactNode;
  onCancel: () => void;
  onOk?: () => Promise<any>;
  updateData?: () => void;
  setVisibility: (param: any) => void;
  buttonLabel?: string;
  showToast?: boolean;
  successMessage?: string;
}

const DeleteConfirmationModal: React.FC<IDeleteConfirmationModalProps> = ({
  title,
  visibility,
  onCancel,
  onOk,
  body,
  updateData,
  setVisibility,
  buttonLabel,
  showToast = true,
  successMessage
}) => {
  const [loading, setLoading] = useState(false);
  const handleOnOk = () => {
    setLoading(true);
    const finish = () => {
      setLoading(false);
      updateData?.();
      setVisibility(false);
      showToast && message.success(successMessage || "Deletado com sucesso");
    };
    if (onOk) {
      onOk()
        .then(() => finish())
        .catch((err) => {
          showToast && message.error("Algo deu errado");
          setLoading(false);
        });
    } else {
      finish();
    }
  };
  return (
    <Modal
      title={title}
      footer={null}
      destroyOnClose
      onCancel={onCancel}
      visible={visibility}
      maskClosable={false}
    >
      <p>{body}</p>
      <Divider />
      <Row gutter={16}>
        <Col span={12}>
          <Button
            size="large"
            color="inherit"
            variant="contained"
            disabled={loading}
            onClick={onCancel}
            className="full-width"
          >
            Cancelar
          </Button>
        </Col>
        <Col span={12}>
          <Button
            size="large"
            color="secondary"
            variant="contained"
            disabled={loading}
            onClick={handleOnOk}
            className="full-width"
          >
            {loading && <LoadingOutlined />}
            {buttonLabel || "Deletar"}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeleteConfirmationModal;
